export const sectionHyperlinks = [
  { label: "Home", href: "#" },
  { label: "Features", href: "#Features" },
  { label: "Testimonial", href: "#Testimonial" },
  { label: "FAQ", href: "#" },
  { label: "Contact Us", href: "#" },
]

export const headerHeight = "4.5rem"
